export default __webpack_public_path__ + "static/93-e24cb5378c15967f2cb3f105b1a86bc7.gif";